import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import WhatsAppSetup from "./WhatsAppSetup";
import WhatsAppCompose from "./WhatsAppCompose";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { userDataSelector } from "../../../redux/selectors/user.selector";
import useCampaignApis from "../../../hooks/useCampaignApis";
import CampaignPageSkeleton from "../components/CampaignPageSkeleton";
import { RootState } from "../../../redux/store";

const WhatsApp = () => {
  const location = useLocation();

  const [editMode, setEditMode] = useState<number>(0);
  const [stepsCompleted, setStepsCompleted] = useState<number>(0);
  const [showLoader, setShowLoader] = useState<boolean>(true);

  const { userData } = useSelector(userDataSelector);
  const masterData = useSelector((state: RootState) => state.campaign.masterData);

  // query params
  const { initiationId, campaignId, profileCount } = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return {
      initiationId: searchParams.get("initiationId") || null,
      campaignId: searchParams.get("campaignId") || null,
      profileCount: searchParams.get("profileCount") || null
    };
  }, [location.search]);

  // to make all apis calls
  const { campaignDraftData, isCampaignDraftError, isCampaignDraftSuccess } =
    useCampaignApis({
      campaignId,
      initiationId,
      userData,
      profileCount: profileCount ? parseInt(profileCount) : null,
      masterData
    });

  const handleEditClick = useCallback((step: number) => {
    setEditMode(step);
  }, []);

  const handleSaveAndContinueSuccess = useCallback(()=>{
    setEditMode(1);
    setStepsCompleted(1);
  },[]);

  useEffect(() => {
    if (isCampaignDraftSuccess && campaignDraftData) {
      // const numberOfCompletedSteps = +campaignDraftData?.campaignJobDescription?.stepsCompleted || 0;

      // setStepsCompleted(numberOfCompletedSteps);

      // if (numberOfCompletedSteps === 2) {
      //   setEditMode(1);
      // } else if (numberOfCompletedSteps < editMode) {
      //   setEditMode(0);
      // }

      setShowLoader(false);
    }

    // to handle error case for loader
    if (campaignId && isCampaignDraftError) {
      setShowLoader(false);
    }
  }, [
    campaignDraftData?.campaignDetail?.nextStep,
    editMode,
    campaignDraftData,
    isCampaignDraftSuccess,
    campaignId,
    isCampaignDraftError,
  ]);

  // skeleton loader
  if (campaignId && showLoader) {
    return <CampaignPageSkeleton />;
  }

  return (
    <Box sx={{ py: 2 }}>
      {/* Whats app campaign */}

      {/*  Step 1 - Set up  */}
      <WhatsAppSetup
        stepsCompleted={stepsCompleted}
        isEditMode={editMode === 0}
        handleEditClick={handleEditClick}
        stepNumber={0}
        handleSaveAndContinueSuccess={handleSaveAndContinueSuccess}
        campaignId={campaignId || ""}
        initiationId={initiationId || ""}
      />

      {/* Step 2 - Compose */}
      <WhatsAppCompose
        stepsCompleted={stepsCompleted}
        isEditMode={editMode === 1}
        handleEditClick={handleEditClick}
        stepNumber={1}
        campaignId={campaignId || ""}
        initiationId={initiationId || ""}
      />
    </Box>
  );
};

export default WhatsApp;
